import Entity from '../Entity';

export default class HelpCategory implements Entity {
  constructor(public id: number, public name: string) {}
}
